import HTTP from './http'
const BASE_URL = '/carriers'

export default {
  /**
   * Get a list of all carriers
   * @param {Boolean} hasMissingDocuments If true, only show carriers with missing uploads
   * @returns {Promise<*>}
   */
  async list({ hasMissingDocuments } = {}) {
    const params = {
      hasMissingDocuments
    }
    const response = await HTTP.get(`${BASE_URL}`, { params })
    return response.data.data
  },

  /**
   * Perform a partial update (aka: a patch) of the carrier profile information
   *
   * @param {UUID} carrierId The carrierKey that uniquely identifies the carrier
   * @param {Object} data The data to use for the patch
   * @returns {Promise<*>}
   */
  async partialUpdate({ carrierId, data }) {
    const response = await HTTP.patch(`${BASE_URL}/${carrierId}`, data)
    return response.data.data
  }
}
